import React, { Fragment, useContext } from 'react';

import { Input as InputField } from 'formlabs-web-components/Form';
import { FormContext } from './Form';

const Input = ({
  name,
  value,
  type = 'text',
  label,
  isRequired,
  placeholder,
  hideLabel,
  ...props
}) => {
  const { formName, invalidFields } = useContext(FormContext);
  const id = `${formName}_${type}_${name}`;
  const hasError = invalidFields.includes(name);

  return (
    <Fragment>
      {label && !hideLabel ? (
        <label aria-hidden="true" htmlFor={id}>
          {label}
        </label>
      ) : null}
      <InputField
        id={id}
        name={name}
        type={type}
        value={value || ''}
        required={isRequired}
        placeholder={placeholder}
        hasError={hasError}
        aria-label={label}
        {...props}
      />
    </Fragment>
  );
};

export default Input;
